
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/result",
      function () {
        return require("private-next-pages/result.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/result"])
      });
    }
  